import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShapeStarFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M22.44 8.68L16.42 13.48L18.46 20.96L12.02 16.68L5.56 20.96L7.6 13.48L1.58 8.68L9.28 8.3L12.02 1.12L14.74 8.3L22.44 8.68Z" />
    </SvgIcon>
  );
});
